
export default function(state=null,action){
    switch (action.type) {
      case "DELAY_REASONS":
          return action.payload;
      default: return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_delay_reasons.js